const initialState =
{
	groupMemberList        : [],
	getGroupListInProgress : false,
	callReconnecting       : false,
	callDetails            : null
};

const privateChat = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'SET_GROUP_MEMBER_LIST': {

			const { memberList } = action.payload;

			return { ...state, groupMemberList: memberList };

		}
		case 'SET_GET_GROUP_LIST_INPROGRESS': {
			console.log('action.payload=======', action.payload);

			return { ...state, getGroupListInProgress: action.payload };
		}

		case 'SET_CALL_RECONNECTING': {
			return { ...state, callReconnecting: action.payload };
		}
		case 'SET_CALL_DETAILS':
		{
			return { ...state, callDetails: action.payload };
		}
		case 'SET_USER_STATUS':
		{

			const { id, status } = action.payload;

			const copyData = { ...state.groupMemberList };

			if (copyData[id])
			{
				copyData[id] = {
					...copyData[id],
					status : status
				};
			}

			console.log('copyDatacopyDatacopyData', { ...copyData });

			return { ...state, groupMemberList: { ...copyData } };
		}

		default:
			return state;
	}
};

export default privateChat;
